import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { ESaleType } from '../../../../../../../json_query';
import { changeMortgageCheckbox, setSaleTypes } from '../../../../../../state/advanced/sale_type';

import { SaleType as SaleTypeComponent } from './saleType';

export const SaleType = connect(
  (state: IAppState) => ({
    saleTypes: (state.filters.jsonQuery.sost_type && state.filters.jsonQuery.sost_type.value) || [],
    mortgage: (state.filters.jsonQuery.ipoteka && state.filters.jsonQuery.ipoteka.value) || false,
  }),
  (dispatch: Dispatch) => ({
    onSaleTypesChange: (value: ESaleType[]) => {
      dispatch(setSaleTypes(value));
    },
    onMortgageChange: (value: boolean) => {
      dispatch(changeMortgageCheckbox(value));
    },
  }),
)(SaleTypeComponent);
